module.exports = __webpack_public_path__ + "434936798ee6e76e83fe75e5f84b3728.fbx";